import React, { useState } from 'react';
import './Contact.css';
import http from '../../interceptor/httpservice';

const Contact = () => {
  const [marketingOptIn, setMarketingOptIn] = useState(false);
  const [formStatus, setFormStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);
    const name = formData.get('name');
    const email = formData.get('email');
    const message = formData.get('message');

    setIsSubmitting(true);
    setFormStatus('');

    try {
        await http.post('/api/v1/emails', {
            name,
            email,
            message,
            marketingOptIn,
            body: `Name: ${name}\nMessage: ${message}\nMarketing opt-in: ${marketingOptIn ? 'Yes' : 'No'}`
        });

        form.reset();
        setMarketingOptIn(false);
        setFormStatus("Thanks for contacting us. We'll get back to you as soon as possible.");
    } catch (error) {
        setFormStatus('We could not submit your message right now. Please try again.');
    } finally {
        setIsSubmitting(false);
    }
  };

  return (
    
    <div className="contact-page">

      <main>

        <section className="contact__area contact__area--modern">
            <div className="container">
                <div className="contact__modern-shell">
                    <div className="contact__content">
                        <span className="contact__eyebrow">Contact Us</span>
                        <h1>Need to get in touch?</h1>
                        <p>
                            Send us your question and the BRAVE Athleisure team will get back to you shortly.
                        </p>

                    </div>

                    <div className="contact__form-panel">
                        <div className="contact__form">
                            <form onSubmit={handleSubmit}>
                                <div className="contact__form-title">
                                    <span className="contact__form-title-spacer" aria-hidden="true">&nbsp;</span>
                                    <h2>Tell us how we can help.</h2>
                                </div>
                                <div className="contact__form-input">
                                    <label htmlFor="contact-name">Name</label>
                                    <input id="contact-name" name="name" type="text" placeholder="Your name" required />
                                </div>
                                <div className="contact__form-input">
                                    <label htmlFor="contact-email">Email</label>
                                    <input id="contact-email" name="email" type="email" placeholder="you@example.com" required />
                                </div>
                                <div className="contact__form-input">
                                    <label htmlFor="contact-message">Message</label>
                                    <textarea id="contact-message" name="message" placeholder="How can we help?" required></textarea>
                                </div>
                                <label className="contact__marketing-optin">
                                    <input
                                        type="checkbox"
                                        checked={marketingOptIn}
                                        onChange={(e) => setMarketingOptIn(e.target.checked)}
                                    />
                                    <span>
                                        Yes, I would like to receive marketing communications about BRAVE Athleisure products. I understand that I can unsubscribe at any time.
                                    </span>
                                </label>
                                {formStatus && (
                                    <p className="contact__form-status" role="status">{formStatus}</p>
                                )}
                                <button className="contact__form-btn" type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? 'Sending...' : 'Send Message'}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
      </main>

    </div>

  )
}

export default Contact
